<template>
  <article id="keyword-wrapper" class="contents-wrapper">
    <router-view />
  </article>
</template>

<script lang="ts">
export default {
  setup() {
    return {};
  },
  created() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped></style>
